import { RegularPlanSheetVariant } from '../../types/mf-execution.types'

export function getRegularPlanSheetConfig(variant: RegularPlanSheetVariant): {
  heading: string
  content: string
} {
  if (variant === RegularPlanSheetVariant.WITHDRAW) {
    return {
      heading: 'Withdrawals from Regular Plans not supported',
      content: `Your investment in this fund is held as a Regular Plan, 
      which was bought through a broker. Withdrawals can only be placed through the same broker.`
    }
  }

  return {
    heading: 'Investments in Regular Plans not supported',
    content: `We only offer Direct Plans to help you invest at lower expense ratios, so you keep more of your returns. 
      A Direct Plan is basically the same fund without broker commissions.`
  }
}
